module.exports = __webpack_public_path__ + "img/cash-register.1b77a6fd.svg";